import PropTypes from "prop-types";

const neutral = (
  <svg
    className="w-2.5 text-gray-400 dark:text-dark-400"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 401.998 401.998"
    fill="currentColor"
  >
    <path d="M73.092 164.452h255.813c4.949 0 9.233-1.807 12.848-5.424 3.613-3.616 5.427-7.898 5.427-12.847s-1.813-9.229-5.427-12.85L213.846 5.424C210.232 1.812 205.951 0 200.999 0s-9.233 1.812-12.85 5.424L60.242 133.331c-3.617 3.617-5.424 7.901-5.424 12.85 0 4.948 1.807 9.231 5.424 12.847 3.621 3.617 7.902 5.424 12.85 5.424zM328.905 237.549H73.092c-4.952 0-9.233 1.808-12.85 5.421-3.617 3.617-5.424 7.898-5.424 12.847s1.807 9.233 5.424 12.848L188.149 396.57c3.621 3.617 7.902 5.428 12.85 5.428s9.233-1.811 12.847-5.428l127.907-127.906c3.613-3.614 5.427-7.898 5.427-12.848 0-4.948-1.813-9.229-5.427-12.847-3.614-3.616-7.899-5.42-12.848-5.42z" />
  </svg>
);

const asc = (
  <svg
    className="w-2.5 text-gray-500 dark:text-dark-300"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 292.362 292.361"
  >
    <path d="M286.935 197.287 159.028 69.381c-3.613-3.617-7.895-5.424-12.847-5.424s-9.233 1.807-12.85 5.424L5.424 197.287C1.807 200.904 0 205.186 0 210.134s1.807 9.233 5.424 12.847c3.621 3.617 7.902 5.425 12.85 5.425h255.813c4.949 0 9.233-1.808 12.848-5.425 3.613-3.613 5.427-7.898 5.427-12.847s-1.814-9.23-5.427-12.847z" />
  </svg>
);

const desc = (
  <svg
    className="w-2.5 text-gray-500 dark:text-dark-300"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 292.362 292.362"
    fill="currentColor"
  >
    <path d="M286.935 69.377c-3.614-3.617-7.898-5.424-12.848-5.424H18.274c-4.952 0-9.233 1.807-12.85 5.424C1.807 72.998 0 77.279 0 82.228c0 4.948 1.807 9.229 5.424 12.847l127.907 127.907c3.621 3.617 7.902 5.428 12.85 5.428s9.233-1.811 12.847-5.428L286.935 95.074c3.613-3.617 5.427-7.898 5.427-12.847 0-4.948-1.814-9.229-5.427-12.85z" />
  </svg>
);

export function TableSortIcon({ sorted }) {
  return sorted === "asc" ? asc : sorted === "desc" ? desc : neutral;
}

TableSortIcon.propTypes = {
  sorted: PropTypes.oneOf(["asc", "desc", false]),
};
